import React from 'react';
import { CustomArrowProps } from 'react-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Image from 'next/image';

import leftArrow from '@/assets/icons/product-slider-left-arrow.svg';

const PrevArrow = (props: CustomArrowProps) => {
  const { className, style, onClick } = props;

  return (
    // <ChevronLeftOutlined
    //   style={{ ...style, display: 'block' }}
    //   className={`${className} -translate-y-1/2 text-black hover:text-primary`}
    //   fontSize="large"
    //   onClick={onClick}
    // />
    <div className={`${className} arrow-slider-main before:v2-hidden -left-3 -translate-y-1/2`}>
      <Image src={leftArrow} className="" alt="Left Arrow" onClick={onClick} />
    </div>
  );
};

export default PrevArrow;
